import { render } from "./ChallengeModal.vue?vue&type=template&id=39a47fd0"
import script from "./ChallengeModal.vue?vue&type=script&lang=js"
export * from "./ChallengeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__